module.exports = __webpack_public_path__ + "img/1531019977.207fe6ea.jpg";